export const USER_DETAILS_SUBMITTED = 'USER_DETAILS_SUBMITTED';
export const CLEAR_AUTH_STORE = 'CLEAR_AUTH_STORE';
